import qs from 'query-string';
import {Filter, PaginationState, Shop} from 'interfaces';

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export function filtersToQueryStringObject(filters: Filter[]) {
  return filters.reduce((query, filter) => {
    const options = filter.options
    .filter((option) => option.checked)
    .map((option) => option.optionId)
    .join(',');

    if (options) {
      query[filter.type] = options;
    }

    return query;
  }, {});
}

function getTruthyProperties(params) {
  Object.keys(params).forEach((param) => {
    if (!params[param]) {
      delete params[param];
    }
  });
  return params;
}

function formatParamKeys(params) {
  Object.keys(params).forEach((param) => {
    if (param === 'categoryId') {
      params.display_in_category_id = params.categoryId; // eslint-disable-line
      delete params.categoryId;
    }
  });
  return params;
}

const ShopCache = new Map();

export interface GetShopsOptions {
  path: string;
  page?: number;
  sortBy: string;
  filters: Filter[];
  categoryId?: string;
  queryToUrl?: boolean;
}

export interface ShopsResponse {
  shops: Shop[];
  filters: Filter[];
  pagination: PaginationState;
  nextPageURL: string;
  shopsCountString: string;
}

interface ShopCacheObject {
  opt: GetShopsOptions;
  url: string;
  shops: ShopsResponse;
  pathname?: string;
}

export type ShopsHistoryState = GetShopsOptions & ShopsResponse;

function serializeToHistory(opt, shops, pathname) {
  const historyState: ShopsHistoryState = {
    ...opt,
    ...shops,
  };

  history.pushState(historyState, document.title, pathname);
}

export async function getShops(opt: GetShopsOptions): Promise<ShopsResponse|null> {
  const {path, filters, queryToUrl = false, ...params} = opt;
  let url = path;

  const baseQuery = formatParamKeys(getTruthyProperties(params));
  const query = Object.assign(baseQuery, filtersToQueryStringObject(filters));
  const queryString = qs.stringify(query);

  if (queryString) {
    url += `?${queryString}`;
  }

  if (ShopCache.has(url)) {
    const {opt, shops, pathname} = ShopCache.get(url);

    if (pathname) {
      serializeToHistory(opt, shops, pathname);
    }

    return shops;
  }

  let shops;

  try {
    const response = await fetch(url, {headers});
    shops = await response.json();
  } catch (error) {
    return null;
  }

  const cacheObject: ShopCacheObject = {opt, url, shops};

  if (queryToUrl) {
    let pathname = location.pathname;
    if (queryString) {
      pathname += `?${queryString}`;
    }
    serializeToHistory(opt, shops, pathname);
    cacheObject.pathname = pathname;
  }

  ShopCache.set(url, cacheObject);
  return shops;
}
